export default {
  watch: {
    events() {
      if (! this.elementEvents.length) {
        return
      }
      this.handleEvents()
    }
  },
  computed: {
    elementEvents() {
      return this.events.filter(valueProp => valueProp.elements.includes(this.element))
    },
    events() {
      return this.$store.getters['eventModule/events']
    }
  },
  methods: {
    handleEvents() {
      this.elementEvents.forEach(event => this.fireEvent(event))
    },
    fireEvent(event) {
      this.addToArray(event.module, event.value, event.array, this.device)
    }
  }
}